<app-loading-overlay [isLoading]="profServ.sub_processing" [fullscreen]="true" class="dialog-fill">
  <bv-dialog-title>{{ "PAY_INVOICE" | translate }}</bv-dialog-title>
  <bv-dialog-body class="min-500">
    <div class="push-top">
      <app-credit-card></app-credit-card>
    </div>
  </bv-dialog-body>
  <bv-dialog-footer>
    <app-close-dialog-button></app-close-dialog-button>
    @if (profServ.latestProfile?.amount_due > 0) {
      <button
        id="btn_pay_invoice"
        bv-button variant="primary"
        (click)="payInvoice()"
        >
        {{ "PAY_INVOICE" | translate }}
        {{
        amount_due
        | currency : profServ.latestProfile?.currency : "symbol-narrow"
        }}
      </button>
    }
  </bv-dialog-footer>
</app-loading-overlay>
